export default {
  
  mn(state) { return state.mn },
  userId(state) { return state.userId },
  userName(state) { return state.userName },
  userAllowed(state) { return state.userAllowed },
  userIsAdmin(state) { return state.userIsAdmin },
  
};